import makeServiceData from '@pages/AdditionalServices/containers/methods/basket/makeServiceData';
import { SetUpServiceData } from '@pages/AdditionalServices/containers/methods/basket/types';

export function compareCurrentAndRestoredServicesWithoutIds(variantId: string, restoredData: any) {
  const actualServiceDataWithoutIds = makeServiceData(variantId).map((service, index) => {
    let resultService = service;
    if (index === 0) {
      const { SelectedProductUUID: _, ...restSetUpService } = service as SetUpServiceData;
      resultService = restSetUpService;
    }
    const {
      service: { stateID, ...restService },
    } = resultService;
    return { ...resultService, service: restService };
  });
  const shareServiceDataWithoutIds = (restoredData ?? []).map((service, index) => {
    let resultService = service;
    if (index === 0) {
      const { SelectedProductUUID: _, ...restSetUpService } = service as SetUpServiceData;
      resultService = restSetUpService;
    }
    const {
      service: { stateID, ...restService },
    } = resultService;
    return { ...resultService, service: restService };
  });

  return JSON.stringify(shareServiceDataWithoutIds) === JSON.stringify(actualServiceDataWithoutIds);
}
